module.exports = __webpack_public_path__ + "static/media/YouTube.6ab80762.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/YouTube.png
// module id = 2089
// module chunks = 0